<template>
  <div class="login-container py-3 py-lg-5  col-12">
    <div class="row mx-0 col-12 col-sm-8 col-lg-7 mx-auto px-0">
      <div class="col-12 mx-auto py-3 py-lg-5 page-dark-bg px-0">
        <h4 class="w-100 text-center my-3 my-lg-4 page-main-title text-white">
          Вход в личный кабинет
        </h4>
        <b-form
                class="login-form py-4" autocomplete="off"
                @submit.prevent="Login">
          <div class="col-12 col-md-9 col-lg-5 mx-auto mb-3 px-0 px-lg-2">
            <div class="col-12">
              <div class="input-group mb-4">
                <div class="col-12">
                  <input
                          v-model="payload.login"
                          class="form-control auth-input"
                          required
                          type="text"
                          placeholder="Ваш логин"
                  >
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="input-group mb-4">
                <div class="col-12">
                  <input v-model="payload.password"
                          type="password"
                          class="form-control auth-input"
                          required
                          placeholder="Ваш пароль"
                  >
                </div>
              </div>
            </div>

            <div class="col-12 mb-3">
              <alert :message="response" class="px-3" />
            </div>

            <div class="col-12">
              <div class="col-12 col-md-7 mx-auto">
                <div class="green-btn-bg">
                  <button
                          name="submit"
                          class="btn main-btn w-100 red-btn" :disabled="isSubmitting"
                          @click.prevent="Login">
                    Войти
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-form>

        <div class="col-12 col-md-9 col-lg-8 mx-auto justify-content-between row px-0 px-lg-2">
          <div class="col-12 col-lg-6">
            <div class="mx-auto col-12 text-center">
                <button class="btn dark-btn w-100" @click="openRecoverModal">
                  Забыли пароль?
                </button>
            </div>
          </div>
          <div class="col-12 col-lg-6 mt-3 mt-md-0">
            <div class="mx-auto col-12 text-center text-lg-right">
              <router-link class="btn dark-btn w-100" :to="{ path: '/registration' }">
                Зарегистрироватся
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Alert from '@/components/Alert'

  export default {
    name: 'Login',
    components: {
      Alert
    },
    data () {
      return {
        response: null,
        isSubmitting: false,
        showRecoverModal: false,
        payload: {
          login: '',
          password: ''
        }
      }
    },
    computed: {
      userData () {
        return this.$store.getters.userData
      }
    },
    methods: {
      openRecoverModal () {
        this.showRecoverModal = true
        return this.$root.$emit('bv::show::modal', 'recoverAccountModal')
      },
      Login () {
        this.response = { status: 'loading' }
        this.isSubmitting = true
        this.axios.post(
                this.$_config.baseUrl + '/Api/Login', {
                  authorize: this.payload
                }
        ).then((userData) => {
          const data = userData.data
          this.isSubmitting = false
          this.response = data
          if (data.status === 'ok') {
            this.$store.dispatch('fetchUserData')
            this.response = { status: 'ok', msg: 'Добро пожаловать' }
            this.$store.dispatch('fetchMessages')
            this.$store.dispatch('fetchWheelStatistic')
            this.$store.dispatch("getMainSettings")
            this.$store.dispatch("fetchApiData")
            window.location.reload()
          }
        }).catch((err) => {
          if (err) {
            this.isSubmitting = false
            this.response = { status: 'error', msg: "Что-то пошло не так." }
          }
        })
      }
    },
    mounted () {
      if (this.userData) {
        this.$router.push({ name: 'home' })
      }
      window.scrollTo({
        top: 0
      })
    },
    watch: {
      userData () {
        if (this.userData) {
          this.$router.push({ path: '/' })
        }
      }
    }
  }
</script>